module.exports = __webpack_public_path__ + "static/media/notification.cea5ba59.svg";